export default __webpack_public_path__ + "static/media/Logout.8382802b.svg";